<template>
  <b-container fluid>
    <b-row class="mb-4 justify-content-between" style="gap:20px">
      <b-col cols="12" xl="7" md="6" class="mb-2">
        <SearchInput v-model="filters.name" />
      </b-col>

      <b-col cols="12" xl="4" md="6" class="mb-2 ">
        <div class="d-flex justify-content-end" style="gap: 40px;">
          <b-button
            @click="assignToSelectedCustomer()"
            variant="primary"
            style="float: right"
            :disabled="isSending"
            class="btn btn-secondary btn--h46px justify-content-center px-5"
          >
          <b-spinner v-if="isSending" small class="mr-2"></b-spinner>
           <span class="mr-2" v-else>+</span> 提供
          </b-button>
          <b-button
            @click="assignToAllCustomer()"
            variant="primary"
            :disabled="isSubmitting"
            style="float: right"
            class="btn btn-secondary btn--h46px justify-content-center px-5"
          >
          <b-spinner v-if="isSubmitting" small class="mr-2"></b-spinner>
           <span class="mr-2" v-else>+</span> 提供全部
          </b-button>
        </div>
      </b-col>
      <b-col cols="12" xl="2" md="2" class="mb-2">
      </b-col>

    </b-row>

    <TableData :items="paginatedData" :headers="headers" :isLoading="isLoading">
      <template v-slot:title-transform-checkbox>
        <b-form-checkbox
          @change="handleSelectAllChange"
          :disabled="isLoading"
          v-model="isSelectAll"
        ></b-form-checkbox>
      </template>

      <template v-slot:custom-checkbox="{ item }">
        <b-form-checkbox
          @change="onHandleChangeItem($event, item.id)"
          :checked="checkboxCheckedMap(item.id)"
        ></b-form-checkbox>
      </template>

      <template v-slot:custom-action="{ item }">
        <b-dropdown
          variant="link"
          toggle-class="text-white text-decoration-none"
          no-caret
        >
          <template #button-content>
            <b-icon
              icon="three-dots"
              font-scale="1.5"
              class="text-dark"
            ></b-icon>
          </template>

          <b-dropdown-item v-on:click="assignManualCustomer(item.id)">
            <span>+</span> 提供
          </b-dropdown-item>
        </b-dropdown>
      </template>
    </TableData>

    <Pagination
      v-if="!isLoading && paginatedData.length"
      v-model="currentPage"
      :list-data="filterCustomer"
      :limit="limit"
    />
  </b-container>
</template>

<script>
import customerService from '../../../services/customer.service'
import couponService from '../../../services/coupon.service'
import Pagination from '../../Pagination.vue'
import TableData from '../../TableData.vue'
import SearchInput from '../../SearchInput.vue'

export default {
  name: 'LoyaltyPrograms',
  data: () => ({
    customerList: [],
    currentPage: 1,
    limit: 10,
    isBirthDay: true,
    selectedOption: null,

    filters: {
      name: '',
      start: '',
      end: ''
    },

    breadcrumbItems: [
      { label: '優惠券管理', to: '/loyalty-programs' },
      { label: '向客戶提供' }
    ],
    headers: [
      { text: '', value: 'checkbox' },
      { text: '會員編號', value: 'posMemberId' },
      { text: '使用者身分', value: 'id' },
      { text: '姓名', value: 'name' },
      { text: '電話號碼', value: 'phoneNumber' },
      { text: '日期登記', value: 'joinDate' },
      { text: '出生日期', value: 'birthdate' },
      { text: '操作', value: 'action' }
    ],

    isLoading: false,
    isSubmitting: false,
    isSending: false,
    isSelectAll: false,
    customerIds: [],
    customerId: null
  }),

  components: {
    Pagination,
    TableData,
    SearchInput
  },

  mounted () {
    this.getAllCustomers()
  },

  computed: {
    filterCustomer () {
      return this.customerList
        .filter((item) =>
          this.filters.name.length ? item?.name?.toLowerCase()
            .replace(/\s+/g, '')
            .includes(this.filters.name.toLowerCase().replace(/\s+/g, '')) ||
          item?.posMemberId?.toLowerCase()
            .replace(/\s+/g, '')
            .includes(this.filters.name.toLowerCase().replace(/\s+/g, '')) ||
            item?.id?.toString().toLowerCase()
              .replace(/\s+/g, '')
              .includes(this.filters.name.toLowerCase().replace(/\s+/g, '')) ||
            item?.phoneNumber?.toString().toLowerCase()
              .replace(/\s+/g, '')
              .includes(this.filters.name.toLowerCase().replace(/\s+/g, ''))
            : true
        ).sort(
          (a, b) =>
            +new Date(b.joinDate) - (+new Date(a.joinDate))
        )
    },

    paginatedData () {
      return this.filterCustomer.slice(
        (this.currentPage - 1) * this.limit,
        this.currentPage * this.limit
      )
    }
  },
  watch: {
    filterCustomer () {
      this.currentPage = 1
    }
  },
  methods: {
    async getAllCustomers () {
      this.isLoading = true
      try {
        const res = await customerService.getAllBirthdayMonthCustomers()
        this.customerList = res.data
      } catch (err) {
        this.makeToast('danger', '發生錯誤，請稍後再試。', err)
      }
      this.isLoading = false
    },

    async assignToSelectedCustomer () {
      if (!this.customerIds.length) {
        this.makeToast('danger', '尚未選擇客戶名單', '發送優惠券前請選擇客戶名單。')
        return
      }
      this.isSending = true
      try {
        const res = await couponService.assignToSelectedCustomers(this.$route.params.id, this.customerIds, this.isBirthDay)
        this.handleResponse(res, '優惠券已提供給選定的客戶')
      } catch (err) {
        this.makeToast('danger', '發生錯誤，請稍後再試。', err)
      }
      this.isSending = false
    },

    async assignToAllCustomer () {
      this.isSubmitting = true
      const customerIds = this.customerList.map(item => item.id)
      try {
        const res = await couponService.assignToSelectedCustomers(this.$route.params.id, customerIds, this.isBirthDay)
        this.handleResponse(res, '優惠券已發放給所有顧客')
      } catch (err) {
        this.makeToast('danger', '發生錯誤，請稍後再試。', err)
      }
      this.isSubmitting = false
    },

    assignManualCustomer (customerId) {
      couponService.assignCustomerToCoupon(this.$route.params.id, customerId, this.isBirthDay).then(
        res => {
          this.handleResponse(res, '優惠券已發給顧客')
        },
        err => {
          this.makeToast('danger', '發生錯誤，請稍後再試。', err)
        }
      )
    },

    handleResponse (res, successMessage) {
      if (res.success) {
        this.makeToast('success', '向客戶提供', successMessage)
      } else {
        this.makeToast('danger', '向客戶提供', res.message)
      }
    },

    makeToast (variant = null, title = 'Title', message = 'Message!') {
      this.$bvToast.toast(message, {
        title: title,
        autoHideDelay: 3000,
        variant: variant,
        solid: true
      })
    },

    handleSelectAllChange (value) {
      this.customerIds = value ? this.customerList.map(item => item.id) : []
    },

    onHandleChangeItem (checked, id) {
      if (checked) {
        this.customerIds.push(id)
      } else {
        this.customerIds = this.customerIds.filter(element => element !== id)
      }
      if (this.isSelectAll) {
        this.isSelectAll = this.customerIds.length === this.customerList.length
      }
    },

    checkboxCheckedMap (id) {
      return this.customerIds.includes(id)
    }
  }
}
</script>
